import { getField, updateField } from 'vuex-map-fields'
import BaseStore from './baseStore'
import api from '../api/api'

export default class {
  constructor(baseUrl) {
    const baseStore = new BaseStore(baseUrl)

    const getDefaultState = () => {
      return {
        ...structuredClone(baseStore.state),
        dirtyObject: null
      }
    }

    this.state = getDefaultState()

    this.mutations = {
      ...baseStore.mutations,
      RESET_STATE(state) {
        Object.assign(state, getDefaultState())
      },
      REPLACE_CURRENT_ITEM(state, createdObj) {
        state.currentItem = createdObj
      },
      EMPTY_ITEM(state) {
        state.items = []
      },
      SET_DIRTY_OBJECT(state, item = null) {
        if (item) {
          state.dirtyObject = item
        } else {
          state.dirtyObject = state.currentItem
        }
      },
      EMPTY_DIRTY_OBJECT(state) {
        state.dirtyObject = null
      },
      TOGGLE_GENERATE_LOADING(state) {
        state.generateLoading = !state.generateLoading
      },
      updateField
    }

    this.actions = {
      ...baseStore.actions,
      resetState({ commit }) {
        commit('RESET_STATE')
      },
      async fetchItems(context, id) {
        let url = baseUrl + `?search=${id}`
        context.commit('RESET_STATE')
        let response = await api.get(url)
        if (response.data) {
          context.commit('SET_ITEMS', response.data)
          let index = context.state.items.findIndex((item) =>
            'number' in item ? item.number === 1 : 0
          )
          index = index !== -1 ? index : 0
          await context.commit('SET_CURRENT_ITEM', context.state.items[index])
          context.commit('ADD_COUNT', response.data['count'])
        }
      },
      async fetchOverviewItem({ state }, stabSchematisationStageId) {
        const url = state.baseUrl
        const response = await api.get(url, { params: { search: stabSchematisationStageId } })
        return response.data
      },
      setDirtyObject(context, item = null) {
        context.commit('SET_DIRTY_OBJECT', item)
      },
      setNestedParameter(context, payload) {
        context.commit('SET_NESTED_PARAMETER', payload)
        context.commit('ADD_DIRTY_ITEM', payload.item)
        context.commit('SET_DIRTY_OBJECT')
      },
      async update(context) {
        const updatedObj = context.state.dirtyObject ? context.state.dirtyObject : {}
        if ('id' in updatedObj) {
          const newObjs = context.state.items.filter((item) => item.id === updatedObj.id)
          const url = baseUrl + `${updatedObj['id']}/`
          const response = await api.patch(url, updatedObj)
          const createdObjs = [response.data]
          context.commit('REPLACE_ITEMS', { newObjs, createdObjs })
          context.commit('SET_CURRENT_ITEM', response.data)
          context.commit('EMPTY_DIRTY_OBJECT')
        }
      }
    }

    this.getters = {
      getField,
      getPolderWaterLevel: (state) => {
        return state.currentItem?.polder_water_level
      },
      getRiverWaterLevel: (state) => {
        return state.currentItem?.river_water_level
      }
    }
  }
}
